import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Table, Pagination, DatePicker, Button, Tooltip, Modal } from 'components';
import { CleanIcon, DownloadIcon, DownloadBlackIcon, EyeBlackIcon } from 'assets/icons';
import { PlanService } from 'services';
import moment from 'moment';
import { Print, Constants, Globals, Colors } from 'utils';
import ModalView from './modal-view';
import ModalStatus from './modal-status';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	since: '',
	until: ''
}

class History extends React.Component<Props> {

	state = {
		data: [],
		page: 1,
		last_page: 1,
		header: [
			'Fecha de Vencimiento',
			'Usuario',
			'Plan de Suscripción',
			'Monto Pagado',
			'Medio de Pago',
			'Nº Referencia',
			'Validación de pago',
			'Estatus suscripción',
			'Acción'
		],
		form: INITIAL_STATE,
		visible: false,
		item: null,
		visible_status: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Historial de Suscripción',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await PlanService.admin.getHistory({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
		});
		this.setState({
			data: res.plan_payments.rows,
			last_page: res.plan_payments.count
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	download = async () => {
		const res: any = await PlanService.admin.download({
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
		});
	    Print(Constants.BASE_STORAGE + res.url);
	}

	downloadPayment = async (e: any, plan_payment_id: number) => {
		e.preventDefault();
		const res: any = await PlanService.admin.downloadPayment({
			...this.state.form,
			plan_payment_id
		});
	    Print(Constants.BASE_STORAGE + res.url);
	}

	getColor = (item: any) => {
		switch(item.status) {
			case Constants.PLAN_PAYMENT_STATUS.PENDING:
				return Colors.danger;
			break;

			case Constants.PLAN_PAYMENT_STATUS.ACCEPTED:
				return Colors.blue;
			break;

			case Constants.PLAN_PAYMENT_STATUS.REJECTED:
				return Colors.danger;
			break;
		}
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		});	
	}

	onCloseStatus = () => {
		this.setState({
			visible_status: false,
			item: null
		},() => this.load(true));	
	}

	changeStatus = (item: any) => {
		this.setState({
			visible_status: true,
			item
		});
	}
	
	render() {
		const { visible, visible_status } = this.state;

		return (
			<div id="admin-plans-history">
				<Modal
		          className="modal-view-payment"
		          visible={ visible }
		          withoutClose={ true }
		          onClose={ () => this.onClose() }
		        >
		          <ModalView
		          	item={ this.state.item }
		            onClose={ () => this.onClose() } />
		      	</Modal>

		      	<Modal
		          className="modal-payment-change-status"
		          visible={ visible_status }
		          withoutClose={ true }
		          onClose={ () => this.onCloseStatus() }
		        >
		          <ModalStatus
		          	item={ this.state.item }
		            onClose={ () => this.onCloseStatus() } />
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-4">
						<DatePicker
							placeholder="Desde"
							onChange={ (text: string) => {
								this.change({
									target: {
										value: text,
										name: 'since'
									}
								},() => this.load(true));
							} }
							value={ this.state.form.since }
						/>
					</div>
					<div className="col-md-4">
						<DatePicker
							placeholder="Hasta"
							onChange={ (text: string) => {
								this.change({
									target: {
										value: text,
										name: 'until'
									}
								},() => this.load(true));
							} }
							value={ this.state.form.until }
						/>
					</div>
					<div className="col-md-2">
						{
							this.state.form != INITIAL_STATE && (
								<button className="btn btn-clean" onClick={ () => this.reset() }>
									<img src={ CleanIcon } />
								</button>
							)
						}
					</div>
				</div>

				<Table title="Historial de suscripción" data={ this.state.data.length } rightAlign={[ 8 ]} header={ this.state.header } titleRight={
					<Button className="btn-add" onClick={ () => this.download() }>
						<img src={ DownloadIcon } />
						Descargar
					</Button>
				}>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ moment(i?.next_payment).isValid() ? moment(i?.next_payment).format('DD-MM-YYYY') : '' }</td>
								<td>{ i?.plan_user?.user?.name }</td>
								<td>{ i?.plan_user?.plan?.name }</td>
								<td className="price">{ Globals.formatMiles(i?.amount) }</td>
								<td>{ i?.payment_method?.name }</td>
								<td>{ i?.reference || '-' }</td>
								<td className="status" onClick={ () => {
									if (i.status == Constants.PLAN_PAYMENT_STATUS.PENDING)
										this.changeStatus(i);
								} } style={{
									color: this.getColor(i),
									cursor: i.status == Constants.PLAN_PAYMENT_STATUS.PENDING ? 'pointer' : 'default'
								}}>{ i?.status_text }</td>
								<td className="status" style={{
									color: i?.plan_user?.user?.last_payment?.id == i?.id && moment(i?.next_payment).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD') ? Colors.green : Colors.danger
								}}>{ i?.plan_user?.user?.last_payment?.id == i?.id && moment(i?.next_payment).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD') ? 'Activo' : 'Inactivo' }</td>
								<td className="vertical-center text-right">
									<Tooltip title="Ver">
										<a className="link-icon" href="#" onClick={ (e: any) => {
											e.preventDefault();
											this.setState({
												visible: true,
												item: i
											});
										} }>
											<img src={ EyeBlackIcon } />
										</a>
									</Tooltip>
									<Tooltip title="Descargar">
										<a className="link-icon" href="#" onClick={ (e: any) => {
											this.downloadPayment(e,i.id)
										} }>
											<img src={ DownloadBlackIcon } />
										</a>
									</Tooltip>
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect()(History);